import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

export default function UserDetail() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.getUser(id);
        if (res?.error) throw new Error(res.error);
        if (alive) setUser(res.item || res);
      } catch (e) {
        if (alive) setError(e.message || 'Failed to load user');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [id]);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 12 }}>
        <Link to="/users" style={{ color: '#60a5fa' }}>← Back to Users</Link>
      </div>
      {loading ? (
        <p>Loading…</p>
      ) : error ? (
        <p style={{ color: '#fca5a5' }}>{String(error)}</p>
      ) : !user ? (
        <p style={{ color: '#9ca3af' }}>Not found</p>
      ) : (
        <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
          <h2 style={{ color: '#ff7a45', marginTop: 0 }}>{user.name || user.email || 'User'}</h2>
          <div style={{ color: '#9ca3af', marginBottom: 12 }}>ID: {user._id}</div>
          <div style={{ color: '#e5e7eb', marginBottom: 6 }}>Email: {user.email}</div>
          {user.name && <div style={{ color: '#e5e7eb', marginBottom: 6 }}>Name: {user.name}</div>}
          {user.avatarUrl && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ color: '#9ca3af', marginBottom: 6 }}>Avatar</div>
              <img src={user.avatarUrl} alt="avatar" style={{ maxWidth: 160, borderRadius: 8 }} />
            </div>
          )}
          {Array.isArray(user.roles) && user.roles.length > 0 && (
            <div style={{ color: '#e5e7eb' }}>Roles: {user.roles.join(', ')}</div>
          )}
          {user.createdAt && <div style={{ color: '#9ca3af' }}>Created: {new Date(user.createdAt).toLocaleString()}</div>}
          {user.updatedAt && <div style={{ color: '#9ca3af' }}>Updated: {new Date(user.updatedAt).toLocaleString()}</div>}
        </div>
      )}
    </div>
  );
}
